import { render } from "./TeamRoleDropdown.vue?vue&type=template&id=0346981d"
import script from "./TeamRoleDropdown.vue?vue&type=script&lang=js"
export * from "./TeamRoleDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script